import { getInternationalEvents } from 'api/internationalEvents';
import { InternationalEventResponse } from 'api/responseTypes';
import { useQuery } from 'react-query';
import { resolveInternationalEventsEnabled } from 'utils/internationalEvents';

export const INTERNATIONAL_EVENTS_QUERY_KEY = 'internationalEvents';

/** Full visible set of international events + the dashboard-controlled exposure mode. */
export const useInternationalEventsQuery = () => {
  const { isLoading, isError, data } = useQuery(
    INTERNATIONAL_EVENTS_QUERY_KEY,
    getInternationalEvents,
  );

  const items: InternationalEventResponse[] = data?.items ?? [];

  return {
    isLoading,
    isError,
    items,
    mode: data?.mode,
    // Default to the compact list until the backend sends the flag, so behaviour
    // stays as it is today; `false` switches to concert-style cards.
    isCompactList: data?.isCompactList ?? true,
  };
};

/** Whether to expose the feature here, per the dashboard mode + current platform. */
export const useIsInternationalEventsEnabled = (): boolean => {
  const { mode } = useInternationalEventsQuery();
  return resolveInternationalEventsEnabled(mode);
};
